import { Shark } from "shark-mvc";
import NousCoreModel from "./NousCoreModel";

class VolumeCollection extends NousCoreModel {
	description = "";
	extraData = {};
	title = "";
	
	constructor (data) {
		super();

		if (data) {
			this.import(data);
		}
	}

	export () {
		const exportData = super.export();

		exportData.extraData = this.exportObjectField("extraData");
		
		return exportData;
	}
}

Shark.registerModel("VolumeCollection", VolumeCollection);

export default VolumeCollection;